import { useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

interface UsePrintProps {
  children: React.ReactNode;
  onPrint: boolean;
  setOnPrint: (bool: boolean) => void;
}

export const PrintComponent = ({
  children,
  onPrint,
  setOnPrint,
}: UsePrintProps) => {
  const componentRef = useRef<HTMLInputElement>(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (onPrint) {
      handlePrint();
      setOnPrint(false);
    }
  }, [handlePrint, onPrint, setOnPrint]);

  return <div ref={componentRef}>{children}</div>;
};
